import { SiteHeader } from '../../shared/components/SiteHeader';
import { SiteFooter } from '../../shared/components/SiteFooter';
import { useLang } from '../../../i18n/LanguageContext';
import { privacyDict } from '../../../i18n/dictionaries/privacy';
import styles from './PrivacyPage.module.css';

export const PrivacyPage = (): JSX.Element => {
  const { lang } = useLang();
  const t = privacyDict[lang];

  return (
    <div className={styles.page}>
      <SiteHeader variant="solid" />

      <div className={styles.titleBlock}>
        <p className={styles.eyebrow}>PRIVACY POLICY</p>
        <h1 className={styles.title}>{t.title}</h1>
      </div>

      <main className={styles.content}>
        <p className={styles.lead}>{t.lead}</p>

        <section className={styles.article}>
          <h2 className={styles.articleTitle}>{t.art1.title}</h2>
          <p>{t.art1.body}</p>
        </section>

        <section className={styles.article}>
          <h2 className={styles.articleTitle}>{t.art2.title}</h2>
          <p>{t.art2.body}</p>
        </section>

        <section className={styles.article}>
          <h2 className={styles.articleTitle}>{t.art3.title}</h2>
          <p>{t.art3.intro}</p>
          <ul className={styles.list}>
            {t.art3.list.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className={styles.article}>
          <h2 className={styles.articleTitle}>{t.art4.title}</h2>
          <ol className={styles.list}>
            {t.art4.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
        </section>

        <section className={styles.article}>
          <h2 className={styles.articleTitle}>{t.art5.title}</h2>
          <ol className={styles.list}>
            <li>
              {t.art5.item1.intro}
              <ul className={styles.list}>
                {t.art5.item1.sub.map((item) => (
                  <li key={item}>{item}</li>
                ))}
                <li>
                  {t.art5.item1.lastSubIntro}
                  <ul className={styles.list}>
                    {t.art5.item1.lastSub.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              {t.art5.item2.intro}
              <ul className={styles.list}>
                {t.art5.item2.sub.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </li>
          </ol>
        </section>

        <section className={styles.article}>
          <h2 className={styles.articleTitle}>{t.art6.title}</h2>
          <ol className={styles.list}>
            <li>
              {t.art6.item1.intro}
              <ul className={styles.list}>
                {t.art6.item1.sub.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </li>
            <li>{t.art6.item2}</li>
          </ol>
        </section>

        <section className={styles.article}>
          <h2 className={styles.articleTitle}>{t.art7.title}</h2>
          <ol className={styles.list}>
            {t.art7.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
        </section>

        <section className={styles.article}>
          <h2 className={styles.articleTitle}>{t.art8.title}</h2>
          <ol className={styles.list}>
            {t.art8.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
        </section>

        <section className={styles.article}>
          <h2 className={styles.articleTitle}>{t.art9.title}</h2>
          <ol className={styles.list}>
            {t.art9.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
        </section>

        <section className={styles.article}>
          <h2 className={styles.articleTitle}>{t.art10.title}</h2>
          <p>{t.art10.intro}</p>
          <div className={styles.contact}>
            <p>{t.art10.address1}</p>
            <p>{t.art10.address2}</p>
            <p>{t.art10.company}</p>
            <p>{t.art10.rep}</p>
            <p>
              {t.art10.emailLabel}
              <a href="mailto:privacy@cji.jp">privacy@cji.jp</a>
            </p>
          </div>
        </section>
      </main>

      <SiteFooter bordered />
    </div>
  );
};
